import { queryOptions } from "@tanstack/react-query";
import { getAllBookings } from "../apis/bookingApi";
import { getAllListings } from "../apis/LaneCageApi";
import { fetchEnquiries } from "../apis/enquiryApi";
import { getAllUsers } from "../apis/userApi";

const getBookings = async () => {
    const response = await getAllBookings()
    return response
}

const getListings = async () => {
    const response = await getAllListings()
    return response
}

const getEnquiries = async () => {
    const response = await fetchEnquiries()
    return response
}

const getUsers = async () => {
    const response = await getAllUsers()
    return response
}

export const manageBookingsQueryOptions = () => {
    return queryOptions({
        queryKey: ["bookings"],
        queryFn: getBookings
    })
}

export const manageListingsQueryOptions = () => {
    return queryOptions({
        queryKey: ["listings"],
        queryFn: getListings
    })
}

export const manageEnquiryQueryOptions = () => {
    return queryOptions({
        queryKey: ["enquiries"],
        queryFn: getEnquiries
    })
}

export const manageUsersQueryOptions = () => {
    return queryOptions({
        queryKey: ["users"],
        queryFn: getUsers
    })
}